import { cn } from "@/lib/utils"

import type { ShareChoice } from "./types"

type SameOrDifferentToggleProps = {
  name: string
  value: ShareChoice
  onChange: (value: ShareChoice) => void
  sameLabel?: string
  differentLabel?: string
}

export function SameOrDifferentToggle({
  name,
  value,
  onChange,
  sameLabel = "Use same",
  differentLabel = "Different",
}: SameOrDifferentToggleProps) {
  return (
    <div
      className="inline-flex rounded-md border border-input bg-muted/40 p-0.5"
      role="radiogroup"
      aria-label="Use same or different"
    >
      {([
        { choice: "same", label: sameLabel },
        { choice: "different", label: differentLabel },
      ] as const).map(({ choice, label }) => {
        const selected = value === choice
        return (
          <button
            key={choice}
            type="button"
            role="radio"
            aria-checked={selected}
            name={name}
            className={cn(
              "cursor-pointer select-none rounded-[6px] px-2.5 py-1 text-xs font-medium transition-colors",
              selected
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            )}
            onClick={() => {
              if (!selected) onChange(choice)
            }}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
